
import * as React from 'react';
import { fluentSvgIconStyles } from '../../../../styles/iconStyles';

export const FilterDismiss20Regular: React.FC<React.SVGProps<SVGSVGElement>> = (props) => {
    return <svg role="img" focusable="false" aria-hidden viewBox="0 0 20 20" width={20} height={20} fill="currentColor" className={props.className} style={{ ...props.style, ...fluentSvgIconStyles }} onClick={props.onClick}>
        <path
            d="M12.5 15a.5.5 0 0 1 .09 1H7.5a.5.5 0 0 1-.09-1h5.09Zm2-4a.5.5 0 0 1 .09 1H5.5a.5.5 0 0 1-.09-1h9.09Zm0-10a4.5 4.5 0 1 1 0 9 4.5 4.5 0 0 1 0-9ZM9.2 7c.1.35.24.68.4 1H3.5a.5.5 0 0 1-.09-1H9.2Zm7.15-3.35a.5.5 0 0 0-.7 0L14.5 4.79l-1.15-1.14a.5.5 0 1 0-.7.7l1.14 1.15-1.14 1.15a.5.5 0 1 0 .7.7l1.15-1.14 1.15 1.14a.5.5 0 1 0 .7-.7L15.21 5.5l1.14-1.15a.5.5 0 0 0 0-.7Z"
            fill="currentColor"
        />
    </svg>
}